import { Debtor } from '../../../containers/PersonalForm/PersonalForm.interface'
import { jobsSelfEmployed } from '../statics/lists'
import { Data } from '../../../interfaces/ApolloResponse.interface'

export const isSelfEmployed =
  (debtor: Debtor = Debtor.PRIMARY) =>
  (state: Data) =>
    jobsSelfEmployed.includes(state.debtors[debtor].currentEmployment.position)
